import { NJButton, NJIcon, NJText } from '@engie-group/fluid-design-system-react';
import type { SharingActions } from './hooks';
import { run } from './parts';
import type { SharingState } from './types';
import illustration from './no-access.svg';

/** « Accès non autorisé » body, shown on any network page opened without access. Illustration: Figma REFONTE NEXT node 1522-109469. */
export function NoAccess({ state, viewerUserId, ownerName, pageLabel, actions }: { state: SharingState; viewerUserId: string; ownerName: string; pageLabel: string; actions: SharingActions }) {
    const request = state.requests.find((r) => r.userId === viewerUserId);
    const sentOn = request ? new Date(request.requestedAt).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' }) : undefined;

    return (
        <section className="ns-denied" aria-labelledby="ns-denied-title">
            <div className="ns-denied__text">
                <h1 id="ns-denied-title" className="ns-denied__title">Accès non autorisé</h1>
                <NJText>Vous n’avez pas les autorisations nécessaires pour accéder à la page {pageLabel} de ce réseau.</NJText>
                <NJText>Ce réseau n’est partagé ni avec vous, ni avec vos équipes. Demandez l’accès à sa propriétaire, {ownerName} : elle sera prévenue dans Size2Mix et par e-mail et pourra vous le partager.</NJText>
                {request ? (
                    <div className="ns-denied__sent" role="status">
                        <NJIcon name="schedule_send" size="sm" />
                        <NJText scale="sm">Demande envoyée le {sentOn}. {ownerName} a été prévenue dans ses notifications Size2Mix et par e-mail ; vous aurez accès dès qu’elle aura partagé le réseau.</NJText>
                    </div>
                ) : (
                    <div>
                        <NJButton
                            label="Demander l’accès"
                            icon="send"
                            scale="lg"
                            disabled={actions.requestAccess.isPending}
                            onClick={() => void run(() => actions.requestAccess.mutateAsync(pageLabel), `Demande envoyée à ${ownerName}, dans Size2Mix et par e-mail`)}
                        />
                    </div>
                )}
            </div>
            <img className="ns-denied__illustration" src={illustration} alt="" width={319} height={337} />
        </section>
    );
}
